import { ReportsApiClient } from '@fourthwall/services/dist/ReportsApiClient'
import { createQueryHook } from '@fourthwall/utils'

export const useAnalyticsReportFiltersQuery = createQueryHook(ReportsApiClient.getReportFilters, {
  queryKey: ['analyticsReportFilters'],
})
